<template>
  <div>
    <div class="card">
      <div class="card-content small-itinerary-body">
        <div class="content">
          <div v-if="nothingBooked">
            <span class="is-size-5">
              Your itinerary is empty
            </span>
            <p class="my-3">
              A summary of your trip will display here as you select your travel
              options.
            </p>
            <p class="my-3">
              <a @click="$nav.searchGo">Start your booking now</a>
            </p>
          </div>

          <div v-if="orderedSegments['flight']">
            <ItineraryFlight
              :segments="orderedSegments['flight']"
              :traveler="profile"
              :guests="$store.state.bookTravel.guests"
              :multiLegs="multiLegs"
              @add="$nav.pushRouteTo({ name: 'BookingFlights'})"
              :show-header="true"
              class="mb-5"
            />
          </div>
          <div v-else>
            <div>
              <b-button
                v-if="!modifyingTrip"
                size="is-default"
                @click="$nav.pushRouteTo({ name: 'BookingFlights'})"
                expanded
                v-html="addText('flight')"
              >
              </b-button>
            </div>
          </div>

          <div v-if="orderedSegments['hotel']">
            <ItineraryHotel
              :sol="orderedSegments['hotel']"
              :key="sol.hotel.key"
              @add="$nav.pushRouteTo({ name: 'BookingHotels'})"
              :show-header="true"
              class="mb-5 pt-6"
            />
          </div>
          <div v-else class="">
            <div class="">
              <b-button
                size="is-default"
                @click="$nav.pushRouteTo({ name: 'BookingHotels'})"
                expanded
                v-html="addText('hotel')"
                class="mb-1"
              >
              </b-button>
            </div>
          </div>

          <div v-if="orderedSegments['car']">
            <ItineraryCar
              :sol="orderedSegments['car']"
              :key="sol.car.id"
              @add="$nav.pushRouteTo({ name: 'BookingCars'})"
              :show-header="true"
              class="mb-5 pt-6"
            />
          </div>
          <div v-else class="">
            <div class="">
              <b-button
                size="is-default"
                @click="$nav.pushRouteTo({ name: 'BookingCars'})"
                expanded
                v-html="addText('car')"
              >
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showFooter"
        class="card-footer is-flex is-justify-content-center"
      >
        <div v-if="!nothingBooked">
          <div v-if="bookTrip.currentlyBooking" class="p-3">
            <b-button
              expanded
              size="is-default"
              label="Proceed to Checkout"
              @click="$nav.pushRouteTo({ name: 'BookingCheckout' })"
              type="is-primary"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin";
import ItineraryFlight from "./ItineraryFlight";
import ItineraryCar from "./ItineraryCar";
import ItineraryHotel from "./ItineraryHotel";

export default {
  name: "SmallItineraryPiece",
  props: {
    sol: Object,
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [bookingMixin],
  components: {
    ItineraryCar,
    ItineraryFlight,
    ItineraryHotel,
  },
  data: function() {
    return {
      maximized: false,
    };
  },
  computed: {
    nothingBooked() {
      var solution = this.$store.state.bookTravel.result;
      return (
        Object.keys(solution.flight).length +
          Object.keys(solution.car).length +
          Object.keys(solution.hotel).length ===
        0
      );
    },
    profile(){
      return this.$store.state.travellersAndTrips.currentTravellerProfile;
    }
  },
  methods: {
    addText(type) {
      let text = `Add a ${type}`;
      if (this.bookingLocation) {
        let lowerCase = this.bookingLocation.city.toLowerCase();
        text = `Add a ${type} near&nbsp;<span class="gant-text">${lowerCase
          .charAt(0)
          .toUpperCase() + lowerCase.slice(1)}</span>`;
      }
      return text;
    },
  },
  mounted() {},
};
</script>

<style>
.small-itinerary,
.small-itinerary-body {
  max-height: 500px;
  overflow-y: auto;
}
</style>
